<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="85%"
            height="100%"
            class="modalDialog"
            no-click-animation
            >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle title="リクエスト予約状況詳細" />
                    <v-container class="mb-4 tableContainer">
                        <v-row class="tableTitle">
                            受付内容
                        </v-row>
                        <v-row>
                            <v-col cols="3">
                                プレー希望日
                            </v-col>
                            <v-col cols="9">
                                {{ this.dateFormated(this.input.playDate) }}
                            </v-col>
                        </v-row>
                        <v-row class="startTimeRow">
                            <v-col cols="1">
                                スタート時間
                            </v-col>
                            <v-col cols="2">
                                <v-row>
                                    <v-col class="border-none border-bottom text-right">
                                        第１希望
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="border-none border-bottom text-right">
                                        第２希望
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="border-none text-right">
                                        第３希望
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="9">
                                <v-row>
                                    <v-col class="tdHeight border-none border-bottom">
                                        {{ input.requestFirstChoice }}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="tdHeight border-none border-bottom">
                                        {{ input.requestSecondChoice }}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="tdHeight border-none">
                                        {{ input.requestThirdChoice }}
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3">
                                組数/人数
                            </v-col>
                            <v-col cols="9">
                                {{ input.cellNumber }} / {{ input.playNumber }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="3">
                                連絡事項
                            </v-col>
                            <v-col cols="9" style="white-space: pre-line;">
                                {{ input.requestContactInfo }}
                            </v-col>
                        </v-row>
                    </v-container>
                    <twoColumnTable
                        title="料金"
                        :cellData="FeeDetail"
                        />
                    <twoColumnTable
                        title="プラン詳細"
                        :cellData="planDetailInfo" />
                    <v-card-actions>
                        <v-btn
                            x-large
                            color="deep-orange"
                            :disabled="isCanceled"
                            @click="displayRemoveOverLay"
                        >
                            予約取消
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            x-large
                            color="primary"
                            :disabled="isCanceled"
                            @click="displayUpdateDialog"
                            >日付変更
                        </v-btn>
                        <v-btn
                            x-large
                            color="primary"
                            :disabled="isCanceled"
                            @click="timeDialogOpen"
                            >枠選択
                        </v-btn>
                        <v-btn
                            x-large
                            color="primary"
                            :disabled="isCanceled"
                            @click="displayCompanion"
                            >同伴者
                        </v-btn>
                        <v-btn
                            x-large
                            v-if="chatboxSetting"
                            color="primary"
                            @click="displayMessageDialog">
                            Chatbox
                        </v-btn>
                        <v-btn
                            x-large
                            color="blue-grey lighten-5"
                            @click="closeModal">
                            閉じる
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <RemoveOverLay
                    page-name="予約"
                    @processing="cancelReserve"
                    @cancel="closeRemoveOverLay"
                    :process-result="process"
                    :overlay-switch="removeOverlay"
                />
                <ReserveUpdate
                    ref="UpdateListView"
                    :received="update"
                    :detailInfo="detailInfo"
                    @refresh-event="getReserveDetail"
                />
                <MessageList
                    ref="MessageListView"
                    :received="passTo"
                    :adminInfo="adminInfo"
                    :golfCourseSelection="golfCourseSelection"
                    @close="closeMessage" />
                <Companion
                    ref="CompanionDialogView"
                    @close-companion="closeCompanionModal"
                    @add-start-time="selectCellDialogOpen($event)"
                    v-show="companionDialog"
                />
                <StartTimeSelect
                    ref="StartTimeModal"
                    :received="update"
                    :childDialog="timeDialog"
                    @success="successClose($event)"
                    @close="closeChild"
                />
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '../../../components/module/CardTitle';
import RemoveOverLay from '@/components/overlay/RemoveOverlay';
import ReserveUpdate from './ReserveUpdate';
import twoColumnTable from '@/components/table/twoColumnTable';
import MessageList from '@/views/Message/MessageList';
import {
    GET_RESERVE,
    CANCEL_RESERVE,
    COMPLETE_RESERVE_CANCEL_EMAIL } from '@/constants/reserve';
import { GET_PLAN_MASTER } from '@/constants/plan';
import Companion from './Companion';
import StartTimeSelect from './StartTimeSelect';

export default {
    components: {
        CardTitle,
        ReserveUpdate,
        RemoveOverLay,
        twoColumnTable,
        MessageList,
        Companion,
        StartTimeSelect
    },
    props: [
        'detailInfo',
        'golfCourseSelection',
        'adminInfo',
        'chatboxSetting'
    ],
    data () {
        return {
            // 削除ダイアログ
            removeOverlay: false,
            // 子のダイアログの状態
            messageDialog: false,
            // ダイアログの表示値
            dialog: false,
            // 入力値
            input: {
                totalFee: '',
                cancelDetail: '',
                planName: '',
                golfName: '',
                playDate: '',
                playStart: '',
                playStyle: [],
                groupinfo: [],
                playNumber: '',
                cellNumber: '',
                detail: '',
                reserveSituation: '',
                requestFirstChoice: '',
                requestSecondChoice: '',
                requestThirdChoice: '',
                requestContactInfo: '',
                addFee2bWeekday: '0',
                addFee2bWeekend: '0',
                addFee3bWeekday: '0',
                addFee3bWeekend: '0',
                cellId: '',
                planId: '',
                golfCode: '',
                playerMin: '',
                playerMax: '',
                playerLeft: '',
                telephone: '',
                reserveType: 0,
                memberClass: 0
            },
            passTo: {
                golfCode: '',
                reserve_no: ''
            },
            // 変更画面に渡す情報
            update: {
                planId: '',
                cellId: '',
                groupNum: 0,
                golfCode: '',
                playerMin: '',
                playerMax: '',
                memberNo: '',
                playDate: '',
                playerLeft: '',
                planName: '',
                telephone: '',
                reserveNo: '',
                playNumber: '',
                reserveType: 0,
                requestFirstChoice: null,
                requestSecondChoice: null,
                requestThirdChoice: null,
                requestContactInfo: null,
                groupInfo: []
            },
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: ''
            },
            planDialog: false,
            timeDialog: false,
            visitedDialog: false,
            companionDialog: false
        };
    },
    watch: {
        'detailInfo.reserve_no' () {
            this.getReserveDetail();
        }
    },
    // 再表示時にページトップにスクロールさせる
    // updated () {
    //     const elements = document.getElementsByClassName('v-dialog--active');
    //     if (!elements || !elements.length) {
    //     // 要素が取得できなかった場合は終了
    //         return;
    //     }
    //     elements[0].scrollTop = 0;
    // },
    computed: {
        isCanceled () {
            return this.input.reserveSituation === '4';
        },
        /** ----------------------------------------------
         * 料金のデータを整形
         * ---------------------------------------------- */
        FeeDetail () {
            return [
                { name: 'お一人様料金', value: this.input.totalFee.toLocaleString() },
                { name: '平日2サム割増', value: this.input.addFee2bWeekday.toLocaleString(), three: true, first: true },
                { name: '休日2サム割増', value: this.input.addFee2bWeekend.toLocaleString(), three: true },
                { name: '平日3サム割増', value: this.input.addFee3bWeekday.toLocaleString(), three: true },
                { name: '休日3サム割増', value: this.input.addFee3bWeekend.toLocaleString(), three: true },
                { name: 'キャンセル', value: this.input.cancelDetail }
            ];
        },
        /** ----------------------------------------------
         * 予約情報のデータを整形
         * ---------------------------------------------- */
        planDetailInfo () {
            return [
                { name: 'プラン名', value: this.input.planName },
                { name: 'ゴルフ場名', value: this.input.golfName },
                { name: 'プレー日', value: this.dateFormated(this.input.playDate) },
                { name: 'スタート時間', value: this.timeFormated(this.input.playStart) },
                { name: '人数', value: `${this.input.playNumber}人` },
                { name: 'プレースタイル', value: this.input.playStyle, arrayType: 'playStyle' },
                // { name: '組数', value: `${Math.ceil(this.input.playNumber / 4)}組` },
                { name: '組数', value: `${this.input.cellNumber}組` },
                { name: 'プラン詳細', value: this.input.detail }
            ];
        }
    },
    methods: {
        /** ----------------------------------------------
         * 日付の表示を修正
         * ---------------------------------------------- */
        dateFormated (data) {
            const date = data.split('-');
            return date[0] + '年' + date[1] + '月' + date[2] + '日';
        },
        /** ----------------------------------------------
         * 時間の表示を修正
         * ---------------------------------------------- */
        timeFormated (data) {
            const time = data.split(':');
            return time[0] + ':' + time[1];
        },
        /** ----------------------------------------------
         * キャメルケースに変換
         * ---------------------------------------------- */
        toCamelCase (str) {
            return str.split('_').map((str, index) => {
                if (index === 0) {
                    return str.toLowerCase();
                }
                return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
            }).join('');
        },
        /** --------------------------------------------
        * 予約情報を取得
        * -------------------------------------------- */
        getReserveDetail () {
            this.$apollo.mutate({
                mutation: GET_RESERVE,
                variables: {
                    reserve_no: this.detailInfo.reserve_no
                }
            }).then(res => {
                const data = res.data.GetReserveDetailFromAdmin.Reserve;
                Object.keys(data).forEach(el => {
                    const camelCase = this.toCamelCase(el);
                    this.$set(this.input, camelCase, data[el]);
                });

                // カート
                this.input.playStyle.cart_code.forEach(element => {
                    switch (element) {
                    case 1:
                        this.input.playStyle.cartCode1 = true;
                        break;
                    case 2:
                        this.input.playStyle.cartCode2 = true;
                        break;
                    case 3:
                        this.input.playStyle.cartCode3 = true;
                        break;
                    case 4:
                        this.input.playStyle.cartCode4 = true;
                        break;
                    case 5:
                        this.input.playStyle.cartCode5 = true;
                        break;
                    case 6:
                        this.input.playStyle.cartCode6 = true;
                        break;
                    case 7:
                        this.input.playStyle.cartCode7 = true;
                        break;
                    case 8:
                        this.input.playStyle.cartCode8 = true;
                        break;
                    case 10:
                        this.input.playStyle.cartCode10 = true;
                        break;
                    }
                });
            });
        },
        /** --------------------------------------------
        * 予約情報をキャンセル
        * -------------------------------------------- */
        cancelReserve () {
            this.process.result = '1';
            this.process.resultText = '処理中です。';
            this.$apollo.mutate({
                mutation: CANCEL_RESERVE,
                variables: {
                    reserve_no: this.detailInfo.reserve_no
                }
            }).then(res => {
                const result = res.data.cancelReserveFromAdmin.result;
                this.process.result = '';
                this.process.resultText = '';
                if (result !== 0) {
                    this.SendCancelEmail();
                    this.closeRemoveOverLay();
                    this.getReserveDetail();
                } else {
                    throw new Error('エラーが発生しました');
                }
            }).catch(error => {
                this.error = error;
            });
        },
        updateInfoRefresh () {
            this.update.memberNo = this.detailInfo.member_no;
            this.update.reserveNo = this.detailInfo.reserve_no;
            this.update.playerMin = this.input.playerMin;
            this.update.playerMax = this.input.playerMax;
            this.update.planId = this.input.planId;
            this.update.cellId = this.input.cellId;
            this.update.playerLeft = this.input.playerLeft;
            this.update.golfCode = this.input.golfCode;
            this.update.reserveType = this.input.reserveType;
            this.update.planName = this.input.planName;
            this.update.playDate = this.input.playDate;
            this.update.telephone = this.input.telephone;
            this.update.memberClass = this.input.memberClass;
            this.update.playNumber = this.input.playNumber;
            this.update.groupNum = this.input.groupinfo.length;
            this.update.requestFirstChoice = this.isEmpty(this.input.requestFirstChoice);
            this.update.requestSecondChoice = this.isEmpty(this.input.requestSecondChoice);
            this.update.requestThirdChoice = this.isEmpty(this.input.requestThirdChoice);
            this.update.requestContactInfo = this.isEmpty(this.input.requestContactInfo);
            this.update.groupInfo = this.input.groupinfo;
        },
        /** ----------------------------------------------
         * 予約キャンセルメールを送る
         * ---------------------------------------------- */
        SendCancelEmail: function () {
            try {
                this.$apollo.mutate({
                    mutation: COMPLETE_RESERVE_CANCEL_EMAIL,
                    variables: {
                        reserve_no: this.detailInfo.reserve_no
                    }
                }).then(res => {
                });
            } catch (error) {
                this.error = error;
            }
        },
        isEmpty (ele) {
            if (ele === ' ') {
                return null;
            }
            return ele;
        },
        /** ------------ ----------------------------------
         * 削除ダイアログを表示する
         * ---------------------------------------------- */
        displayRemoveOverLay () {
            this.removeOverlay = true;
        },
        /** ----------------------------------------------
         * 削除ダイアログを閉じる
         * ---------------------------------------------- */
        closeRemoveOverLay (item) {
            this.process.result = '';
            this.removeOverlay = false;
        },
        /** ----------------------------------------------
         * 予約変更設定画面を表示する
         * ---------------------------------------------- */
        displayUpdateDialog () {
            this.updateInfoRefresh();
            this.$refs.UpdateListView.ModalControl(this.update.reserveNo);
        },
        /** --------------------------------------------
        * モーダル画面を表示
        * -------------------------------------------- */
        openModal () {
            this.dialog = true;
            this.reserve_no = this.detailInfo.reserve_no;
        },
        /** ----------------------------------------------
         * 削除ダイアログを閉じる
         * ---------------------------------------------- */
        closeMessage (item) {
            this.messageDialog = false;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        closeModal () {
            this.dialog = false;
            this.$emit('refresh-event');
        },
        /** ----------------------------------------------
         * メッセージ登録画面を表示する
         * ---------------------------------------------- */
        displayMessageDialog () {
            this.passTo.reserve_no = this.detailInfo.reserve_no;
            this.passTo.golfCode = this.input.golfCode;
            this.$refs.MessageListView.ModalControl(this.detailInfo.member_no);
            this.messageDialog = true;
        },
        /** ----------------------------------------------
         * 同伴者画面を表示する
         * ----------------------------------------------- */
        displayCompanion () {
            this.companionDialog = true;
            this.$refs.CompanionDialogView.OpenDialog(this.detailInfo.reserve_no, false, this.input.planId);
        },
        /** ----------------------------------------------
         * 枠選択画面を表示する
         * ---------------------------------------------- */
        selectCellDialogOpen (info) {
            this.companionDialog = false;
            this.timeDialog = true;
            this.$refs.StartTimeModal.ModalControl(this.input.planId, this.input.playDate, this.input.reserveType, this.input.groupinfo, this.input.planId);
        },
        /** ----------------------------------------------
         * 変更ダイアログを閉じる
         * ---------------------------------------------- */
        closeChild (item) {
            this.companionDialog = false;
            this.planDialog = false;
            this.timeDialog = false;
            if (item) {
                this.cellIdList = item.selectCellId;
            }
        },
        closeCompanionModal () {
            this.companionDialog = false;
            this.refresh();
        },
        /** ----------------------------------------------
         * プラン情報を取得
         * ---------------------------------------------- */
        getPlanMaster (planId) {
            return this.$apollo.query({
                query: GET_PLAN_MASTER,
                fetchPolicy: 'no-cache',
                variables: {
                    plan_id: planId
                }
            }).then(res => {
                const data = res.data.getPlanMaster;
                return data.request_flag;
            });
        },
        /** ----------------------------------------------
         * 人数選択画面を表示する
         * ---------------------------------------------- */
        async timeDialogOpen () {
            this.$store.commit('loading/setIsOpacityLoading', true);
            const planReserveType = await this.getPlanMaster(this.input.planId);
            // リクエスト許可の保証ありプランの場合は通常予約
            if (planReserveType === '0') {
                this.input.reserveType = 1;
            } else {
            // リクエストプランの場合はリクエスト予約
                this.input.reserveType = 3;
            }
            this.updateInfoRefresh();
            this.timeDialog = true;
            this.$refs.StartTimeModal.ModalControl(this.input.planId, this.input.playDate, this.input.reserveType, this.input.groupinfo, this.input.planId);
            this.$store.commit('loading/setIsOpacityLoading', false);
        },
        successClose (reserveNo) {
            this.timeDialog = false;
            this.openVisitedModal();
        },
        openVisitedModal () {
            this.visitedDialog = true;
            this.$refs.CompanionDialogView.OpenDialog(this.detailInfo.reserve_no, false, this.input.planId, 'changeCompanion');
        },
        closeVisitedModal () {
            this.visitedDialog = false;
            this.refresh();
        },
        /** ----------------------------------------------
         * 予約変更が完了した際に走る処理
         * 表示情報を更新する
         * ---------------------------------------------- */
        refresh () {
            this.getReserveDetail();
            this.updateInfoRefresh();
        }
    }
};
</script>

<style scoped>

.title{
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
}

.tdHeight{
    height: 50px;
}

.v-application .title {
    line-height: 3rem;
}

.titleContainer{
    padding-right: 40px;
    padding-left: 40px;
}

.tableTitle{
    padding: 10px;
    border: solid 1px rgba(0,0,0, 0.12);
    border-radius: 10px;
    font-size: 20px;
    font-weight: bold;
}

.tableContainer{
    padding-right: 40px;
    padding-left: 40px;
}

.tableContainer .col{
    border: 1px solid rgba(0, 0, 0, 0.12);
}

.startTimeRow ::v-deep .col:not(:first-child){
    padding: 0 12px;
}
.tableContainer .col.border-none {
    border: none;
}

.tableContainer .col.border-bottom {
    border-bottom: 2px solid rgba(0, 0, 0, 0.12);
}

.button {
    justify-content: space-evenly;
}

</style>
